import script from "./PortfolioModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioModal.vue?vue&type=script&lang=ts&setup=true"

import "./PortfolioModal.vue?vue&type=style&index=0&id=b046c2ac&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b046c2ac"]])

export default __exports__